export default __webpack_public_path__ + "static/media/HeaderTitle2-gu.86d301ed.svg";